<div class="customer-search" [attr.aria-label]="'searchBox.productSearch' | cxTranslate" role="search">
  <label class="searchbox" [class.dirty]="!!searchInput.value">
    <div role="presentation" class="search-icon">
      <i class="aimo-icon icon-sm icon-magnifying-glass"></i>
    </div>

    <input
      #searchInput
      [id]="'customer_search'"
      [placeholder]="'aimo.b2bunit.searchBox.placeholder' | cxTranslate"
      autocomplete="off"
      aria-describedby="initialDescription"
      aria-controls="results"
      [attr.aria-label]="'aimo.b2bunit.searchBox.placeholder' | cxTranslate"
      (focus)="open()"
      (click)="open()"
      (input)="searchB2BUnits(searchInput.value)"
      (keydown.escape)="close($any($event))"
      (keydown.arrowDown)="nextFocus($event, -1, 1)"
      (keydown.enter)="close($any($event)); onlyClear()"
      value="{{ chosenWord }}" />

      <button
        [attr.aria-label]="'common.reset' | cxTranslate"
        (mousedown)="onlyClear()"
        (keydown.enter)="onlyClear()"
        class="reset">
        <i class="aimo-icon icon-sm icon-x"></i>
      </button>
    </label>
  </div>

  @if (searchResult$ | async; as results) {
    <div
      class="results"
      id="results"
      (click)="close($any($event), true)"
      role="dialog">
      <ul class="b2bunits" role="listbox">
        @for (b2bUnit of results; track b2bUnit.uid; let idx = $index) {
          <li
            [ngClass]="{ 'credit-card-user': !b2bUnit.allowInvoices }"
            [attr.aria-label]="'aimo.arialLabel.customer.dropdown' | cxTranslate: { customer: b2bUnit.name }">
            <button
              [id]="'customer_search_' + idx"
              (keydown.arrowDown)="nextFocus($event, idx, results.length)"
              (keydown.arrowUp)="previousFocus($event, idx)"
              class="unit-button"
              (click)="selectUnit($event, b2bUnit.uid)">
              <div class="unit-number">
                <div>{{ b2bUnit.uid }}</div>
                @if (!b2bUnit.allowInvoices) {
                  <i class="aimo-icon icon-credit-card icon-sm icon-red"></i>
                }
              </div>
              <div class="unit-name" (click)="selectUnit($event, b2bUnit.uid)">
                <div class="text-bold" [innerHTML]="b2bUnit.name"></div>
                @if (b2bUnit.addresses?.length > 0) {
                  <div [innerHTML]="b2bUnit.addresses[0].line1"></div>
                  <div>
                    <div class="d-inline-block mr-1" [innerHTML]="b2bUnit.addresses[0].postalCode"></div>
                    <div class="d-inline-block" [innerHTML]="b2bUnit.addresses[0].town"></div>
                  </div>
                }
              </div>
            </button>
          </li>
        }
      </ul>
    </div>
  }
